RivalIQ.apps.AdsInsights.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';


    const AdLabels = RivalIQ.data.CacheLayer.extend({
        name: 'AdLabels',
        cacheKeys: [
            'adAccountId'
        ],

        loadData: function (attrs) {
            const url = [
                '/api/accounts',
                RivalIQ.state.account.get('id'),
                'insights/facebook/ads',
                attrs.adAccountId,
                'adlabels'
            ].join('/');

            return $.get(url);
        }
    });

    data.adLabels = new AdLabels();
});
